import { useEffect } from 'react';
import { b as useTypedDispatch, u as useStrings, o as useNavigation, aD as useNavigate, e as useLocation, f as useTypedSelector, bl as selectActiveSearchParams, ac as selectCurrentVehicle, bJ as isObject, bk as hasProperty, a3 as queueNotification } from './className-0524835a.js';
import { x as useModuleDocumentMessages, d as useDocumentGroupMatch } from './DocumentScreenSkeleton-96f9a1fb.js';

// Delay before returning to check sheet/service record lists to allow time for the document to be updated in Elasticsearch.
const BACK_DELAY = 1000;
function isLocationHashChangeMessage(value) {
    return isObject(value) &&
        hasProperty(value, 'type') && value.type === 'location-hashchange' &&
        hasProperty(value, 'hash') && typeof value.hash === 'string';
}
function isServiceRecordMessage(value) {
    return isObject(value) &&
        hasProperty(value, 'type') && value.type === 'dsr' &&
        hasProperty(value, 'action') && typeof value.action === 'string' &&
        (!hasProperty(value, 'error') || value.error === undefined || typeof value.error === 'string');
}
function useDocumentMessageListener(document, callbacks) {
    const dispatch = useTypedDispatch();
    const strings = useStrings();
    const moduleMessages = useModuleDocumentMessages(document);
    const navigation = useNavigation();
    const navigate = useNavigate();
    const location = useLocation();
    const groupId = useDocumentGroupMatch();
    const search = useTypedSelector(selectActiveSearchParams);
    const vehicle = useTypedSelector(selectCurrentVehicle);
    useEffect(() => {
        function handleLocationHashChangeMessage(message) {
            var _a, _b;
            window.location.hash = message.hash;
            callbacks.onHashChange(message.hash);
            callbacks.onProcedureTitleChange((_a = message.title) !== null && _a !== void 0 ? _a : '');
            callbacks.onProcedureFragmentChange((_b = message.procedureFragment) !== null && _b !== void 0 ? _b : message.hash);
        }
        function handleServiceRecordMessage(message) {
            if (message.error) {
                const error = message.action === 'submit' ? strings.serviceRecords.submitError : message.error;
                dispatch(queueNotification(error));
            }
            if (message.action === 'submit') {
                setTimeout(() => {
                    const params = new URLSearchParams(location.search);
                    const groupId = params.get('group');
                    // when edit DSR url is copied directly without location history, url contains vin and group
                    if (!location.key && vehicle && groupId) {
                        return navigate(navigation.vehicleDocumentGroup(vehicle, groupId));
                    }
                    // when edit DSR url is copied directly without location history, url doesn't contain vin
                    if (!location.key && !vehicle) {
                        return navigate(navigation.home());
                    }
                    navigate(-1);
                }, BACK_DELAY);
            }
        }
        function messageListener({ data }) {
            if (moduleMessages(data)) {
                return;
            }
            if (isLocationHashChangeMessage(data)) {
                handleLocationHashChangeMessage(data);
            }
            else if (isServiceRecordMessage(data)) {
                handleServiceRecordMessage(data);
            }
        }
        window.addEventListener('message', messageListener);
        return () => {
            window.removeEventListener('message', messageListener);
        };
    }, [
        navigate,
        location.key,
        location.search,
        vehicle,
        groupId,
        search,
        dispatch,
        strings.serviceRecords.submitError,
        navigation,
        document,
        moduleMessages,
        callbacks
    ]);
}

export { BACK_DELAY as B, useDocumentMessageListener as u };
